// mulberry32 PRNG (§4.3). The state is a single u32 carried in `MatchState.rng`; ALL in-sim
// randomness draws from it, in the normative order (§7). Pure — never Math.random, never wall clock.

export interface RngHolder {
  rng: number;
}

/**
 * Advance the raw u32 state one step and yield a float in [0,1). Pure (input → {value, state}).
 * Relies on 32-bit two's-complement wraparound via `| 0`, so unsigned/signed round-tripping of the
 * stored state is safe (arithmetic is mod 2^32 either way).
 */
export function rngStep(s: number): { value: number; state: number } {
  const a = (s + 0x6d2b79f5) | 0;
  let t = Math.imul(a ^ (a >>> 15), 1 | a);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  const value = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  return { value, state: a >>> 0 };
}

/** Draw a float in [0,1), advancing `holder.rng` in place (called on step's working clone). */
export function rngFloat(holder: RngHolder): number {
  const { value, state } = rngStep(holder.rng);
  holder.rng = state;
  return value;
}

/** Draw an integer in [0, maxExclusive), advancing `holder.rng`. Callers pass a positive integer. */
export function rngInt(holder: RngHolder, maxExclusive: number): number {
  return Math.floor(rngFloat(holder) * maxExclusive);
}
